import LoginLayout from "./layouts/LoginLayout";   

import Login from "./Pages/Login"  
import Register from "./Pages/Register"   
 

export default [ 
     {
        path: "/",
        exact: true,
        layout: LoginLayout,
        component: Login
     },{
        path: "/register",
        exact: true,
        layout: LoginLayout,
        component: Register
    }
];